module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dohqa"))).then(() => module.bundle.root('hEqeo'));